<div class="audio-container" [hidden]="!isAudioReady"
    [class.link]="item.context === 'link' || item.context === 'applink'"
>
    <img *ngIf="thumbnailUrl; else defaultImg" [src]="thumbnailUrl" alt="Album Art" width="150" height="150">
    <ng-template #defaultImg>
        <img src="assets/images/file-type-audio.png" alt="Audio File">
    </ng-template>
    <audio controls preload="auto" (canplay)="onCanPlay()" (loadedmetadata)="onCanPlay()">
        <source [src]="url" [type]="mimeType">
        Your browser does not support the audio element.
    </audio>
</div>
<div *ngIf="!isAudioReady" class="preview-loading-wrap">
    <sync-spinner></sync-spinner>
</div>